export default {
  autoCompleteType: {
    destination: 'By Destination',
    line: 'By Line',
  },
  tabs: {
    delivery: 'Delivery',
    shuttle: 'Shuttle',
    taxi: 'Taxi',
    airport: 'Airport',
  },
  formDestination: {
    from: 'From',
    to: 'To',
    date: 'Date & Time',
    returnDate: 'Return time',
  },
  formLine: {
    area: 'Area',
    shuttles: 'Lines',
    direction: 'Direction',
    date: 'Date',
    pickup: 'Pickup',
    pickUpTime: 'Hour',
    dropoff: 'Dropoff',
    dropOffTime: 'Hour',
    btnSubmit: 'Book',
    departingFrom: 'Departing From {{stop}}',
    arrivingAt: 'Arriving at {{stop}}',
    departureTime: 'Departure Time',
    arrivalTime: 'Arrival Time',
  },
  passenger: 'Passenger',
  passengers: 'Passengers',
  btnFindServices: 'Search',

  days: '+{{days}}D',

  message: 'This line is available at the following operational times {{times}} Please specify a relevant time.',
};
